/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './paging-bar.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../@angular/material/typings/index.ngfactory';
import * as i3 from '@angular/material';
import * as i4 from '@angular/common';
import * as i5 from '@covalent/core/paging/paging-bar.component';
import * as i6 from '@angular/forms';
const styles_TdPagingBarComponent:any[] = [i0.styles];
export const RenderType_TdPagingBarComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_TdPagingBarComponent,data:{}});
function View_TdPagingBarComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵted((null as any),['\n      '])),(_l()(),i1.ɵeld(0,
      (null as any),(null as any),3,'md-option',[['role','option']],[[1,'tabindex',
          0],[2,'mat-selected',(null as any)],[2,'mat-option-multiple',(null as any)],
          [2,'mat-active',(null as any)],[8,'id',0],[1,'aria-selected',0],[1,'aria-disabled',
              0],[2,'mat-option-disabled',(null as any)],[2,'mat-option',(null as any)]],
      [[(null as any),'click'],[(null as any),'keydown']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,3)._selectViaInteraction()) !== false);
          ad = (pd_0 && ad);
        }
        if (('keydown' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,3)._handleKeydown($event)) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i2.View_MdOption_0,i2.RenderType_MdOption)),i1.ɵdid(16384,(null as any),0,
      i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),
      (null as any)),i1.ɵdid(49152,[[1,4]],0,i3.MdOption,[i1.ElementRef,[2,i3.MATERIAL_COMPATIBILITY_MODE]],
      {value:[0,'value']},(null as any)),(_l()(),i1.ɵted(0,['\n        ','\n      '])),
      (_l()(),i1.ɵted((null as any),['\n    ']))],(_ck,_v) => {
    const currVal_9:any = _v.context.$implicit;
    _ck(_v,3,0,currVal_9);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,3)._getTabIndex();
    const currVal_1:any = i1.ɵnov(_v,3).selected;
    const currVal_2:any = i1.ɵnov(_v,3).multiple;
    const currVal_3:any = i1.ɵnov(_v,3).active;
    const currVal_4:any = i1.ɵnov(_v,3).id;
    const currVal_5:any = i1.ɵnov(_v,3).selected.toString();
    const currVal_6:any = i1.ɵnov(_v,3).disabled.toString();
    const currVal_7:any = i1.ɵnov(_v,3).disabled;
    const currVal_8:any = true;
    _ck(_v,1,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7,currVal_8);
    const currVal_10:any = _v.context.$implicit;
    _ck(_v,4,0,currVal_10);
  });
}
function View_TdPagingBarComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'md-option',[['role',
      'option']],[[1,'tabindex',0],[2,'mat-selected',(null as any)],[2,'mat-option-multiple',
      (null as any)],[2,'mat-active',(null as any)],[8,'id',0],[1,'aria-selected',
      0],[1,'aria-disabled',0],[2,'mat-option-disabled',(null as any)],[2,'mat-option',
      (null as any)]],[[(null as any),'click'],[(null as any),'keydown']],(_v,en,$event) => {
    var ad:boolean = true;
    if (('click' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,2)._selectViaInteraction()) !== false);
      ad = (pd_0 && ad);
    }
    if (('keydown' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,2)._handleKeydown($event)) !== false);
      ad = (pd_1 && ad);
    }
    return ad;
  },i2.View_MdOption_0,i2.RenderType_MdOption)),i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,
      [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(49152,[[1,4]],0,i3.MdOption,[i1.ElementRef,[2,i3.MATERIAL_COMPATIBILITY_MODE]],
          {value:[0,'value']},(null as any)),(_l()(),i1.ɵted(0,['','']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_9:any = _co.total;
    _ck(_v,2,0,currVal_9);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = i1.ɵnov(_v,2)._getTabIndex();
    const currVal_1:any = i1.ɵnov(_v,2).selected;
    const currVal_2:any = i1.ɵnov(_v,2).multiple;
    const currVal_3:any = i1.ɵnov(_v,2).active;
    const currVal_4:any = i1.ɵnov(_v,2).id;
    const currVal_5:any = i1.ɵnov(_v,2).selected.toString();
    const currVal_6:any = i1.ɵnov(_v,2).disabled.toString();
    const currVal_7:any = i1.ɵnov(_v,2).disabled;
    const currVal_8:any = true;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7,currVal_8);
    const currVal_10:any = _co.pageSizeAllText;
    _ck(_v,3,0,currVal_10);
  });
}
function View_TdPagingBarComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),9,'button',[['class',
      'mat-icon-button'],['md-icon-button',''],['type','button']],[[8,'id',0],[8,'disabled',
      0]],[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.firstPage()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },i2.View_MdButton_0,i2.RenderType_MdButton)),i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,
      [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(180224,(null as any),0,i3.MdButton,[i1.ElementRef,i1.Renderer2,i3.Platform,
          i3.FocusOriginMonitor],{disabled:[0,'disabled']},(null as any)),i1.ɵdid(16384,
          (null as any),0,i3.MdIconButtonCssMatStyler,([] as any[]),(null as any),
          (null as any)),(_l()(),i1.ɵted(0,['\n      '])),(_l()(),i1.ɵeld(0,(null as any),
          0,3,'md-icon',[['role','img']],[[2,'mat-icon',(null as any)]],(null as any),
          (null as any),i2.View_MdIcon_0,i2.RenderType_MdIcon)),i1.ɵdid(16384,(null as any),
          0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(9027584,(null as any),0,i3.MdIcon,[i1.ElementRef,
          i1.Renderer2,i3.MdIconRegistry],(null as any),(null as any)),(_l()(),i1.ɵted(0,
          ['',''])),(_l()(),i1.ɵted(0,['\n    ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_2:any = _co.isMinPage();
    _ck(_v,2,0,currVal_2);
    _ck(_v,7,0);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = (('td-paging-bar-' + _co.id) + '-first-page');
    const currVal_1:any = (i1.ɵnov(_v,2).disabled || (null as any));
    _ck(_v,0,0,currVal_0,currVal_1);
    const currVal_3:any = true;
    _ck(_v,5,0,currVal_3);
    const currVal_4:any = (_co.isRTL? 'skip_next': 'skip_previous');
    _ck(_v,8,0,currVal_4);
  });
}
function View_TdPagingBarComponent_5(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵted((null as any),['\n      '])),(_l()(),i1.ɵeld(0,
      (null as any),(null as any),4,'button',[['class','mat-icon-button'],['md-icon-button',
          ''],['type','button']],[[8,'id',0],[8,'disabled',0]],[[(null as any),'click']],
      (_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.navigateToPage(_v.context.$implicit)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i2.View_MdButton_0,i2.RenderType_MdButton)),i1.ɵdid(16384,(null as any),0,
      i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),
      (null as any)),i1.ɵdid(180224,(null as any),0,i3.MdButton,[i1.ElementRef,i1.Renderer2,
      i3.Platform,i3.FocusOriginMonitor],{color:[0,'color']},(null as any)),i1.ɵdid(16384,
      (null as any),0,i3.MdIconButtonCssMatStyler,([] as any[]),(null as any),(null as any)),
      (_l()(),i1.ɵted(0,['',''])),(_l()(),i1.ɵted((null as any),['\n    ']))],(_ck,
      _v) => {
    var _co:any = _v.component;
    const currVal_2:any = ((_co.page === _v.context.$implicit)? 'accent': '');
    _ck(_v,3,0,currVal_2);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = ((('td-paging-bar-' + _co.id) + '-page-link-') + _v.context.index);
    const currVal_1:any = (i1.ɵnov(_v,3).disabled || (null as any));
    _ck(_v,1,0,currVal_0,currVal_1);
    const currVal_3:any = _v.context.$implicit;
    _ck(_v,5,0,currVal_3);
  });
}
function View_TdPagingBarComponent_4(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_TdPagingBarComponent_5)),i1.ɵdid(802816,(null as any),0,i4.NgForOf,[i1.ViewContainerRef,
      i1.TemplateRef,i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),
      i1.ɵand(0,(null as any),(null as any),0))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.pageLinks;
    _ck(_v,1,0,currVal_0);
  },(null as any));
}
function View_TdPagingBarComponent_6(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),9,'button',[['class',
      'mat-icon-button'],['md-icon-button',''],['type','button']],[[8,'id',0],[8,'disabled',
      0]],[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.lastPage()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },i2.View_MdButton_0,i2.RenderType_MdButton)),i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,
      [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(180224,(null as any),0,i3.MdButton,[i1.ElementRef,i1.Renderer2,i3.Platform,
          i3.FocusOriginMonitor],{disabled:[0,'disabled']},(null as any)),i1.ɵdid(16384,
          (null as any),0,i3.MdIconButtonCssMatStyler,([] as any[]),(null as any),
          (null as any)),(_l()(),i1.ɵted(0,['\n      '])),(_l()(),i1.ɵeld(0,(null as any),
          0,3,'md-icon',[['role','img']],[[2,'mat-icon',(null as any)]],(null as any),
          (null as any),i2.View_MdIcon_0,i2.RenderType_MdIcon)),i1.ɵdid(16384,(null as any),
          0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(9027584,(null as any),0,i3.MdIcon,[i1.ElementRef,
          i1.Renderer2,i3.MdIconRegistry],(null as any),(null as any)),(_l()(),i1.ɵted(0,
          ['',''])),(_l()(),i1.ɵted(0,['\n    ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_2:any = _co.isMaxPage();
    _ck(_v,2,0,currVal_2);
    _ck(_v,7,0);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = (('td-paging-bar-' + _co.id) + '-last-page');
    const currVal_1:any = (i1.ɵnov(_v,2).disabled || (null as any));
    _ck(_v,0,0,currVal_0,currVal_1);
    const currVal_3:any = true;
    _ck(_v,5,0,currVal_3);
    const currVal_4:any = (_co.isRTL? 'skip_previous': 'skip_next');
    _ck(_v,8,0,currVal_4);
  });
}
export function View_TdPagingBarComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),57,'div',[['class',
      'md-caption td-paging-bar'],['layout','row'],['layout-align','end center']],
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted((null as any),['\n  '])),i1.ɵncd((null as any),0),(_l()(),i1.ɵted((null as any),
      ['\n  '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),13,'md-select',[['role',
      'listbox']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
      [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
      [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)],[1,'tabindex',
          0],[1,'aria-label',0],[1,'aria-labelledby',0],[1,'aria-required',0],[1,'aria-disabled',
          0],[1,'aria-invalid',0],[1,'aria-owns',0],[2,'mat-select-disabled',(null as any)],
      [2,'mat-select',(null as any)]],[[(null as any),'ngModelChange'],[(null as any),
      'keydown'],[(null as any),'blur']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:i5.TdPagingBarComponent = _v.component;
    if (('keydown' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,9)._handleClosedKeydown($event)) !== false);
      ad = (pd_0 && ad);
    }
    if (('blur' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,9)._onBlur()) !== false);
      ad = (pd_1 && ad);
    }
    if (('ngModelChange' === en)) {
      const pd_2:any = ((<any>(_co.pageSize = $event)) !== false);
      ad = (pd_2 && ad);
    }
    return ad;
  },i2.View_MdSelect_0,i2.RenderType_MdSelect)),i1.ɵdid(671744,(null as any),0,i6.NgModel,
      [[8,(null as any)],[8,(null as any)],[8,(null as any)],[8,(null as any)]],{model:[0,
          'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i6.NgControl,
      (null as any),[i6.NgModel]),i1.ɵdid(16384,(null as any),0,i6.NgControlStatus,
      [i6.NgControl],(null as any),(null as any)),i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,
      [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(1294336,(null as any),1,i3.MdSelect,[i1.ElementRef,i1.Renderer2,i3.ViewportRuler,
          i1.ChangeDetectorRef,[2,i3.Dir],[2,i6.NgControl],[8,(null as any)]],(null as any),
          (null as any)),i1.ɵqud(603979776,1,{options:1}),(_l()(),i1.ɵted(0,['\n    '])),
      (_l()(),i1.ɵand(16777216,(null as any),0,1,(null as any),View_TdPagingBarComponent_1)),
      i1.ɵdid(802816,(null as any),0,i4.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted(0,
          ['\n    '])),(_l()(),i1.ɵand(16777216,(null as any),0,1,(null as any),View_TdPagingBarComponent_2)),
      i1.ɵdid(16384,(null as any),0,i4.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted(0,['\n  '])),(_l()(),i1.ɵted((null as any),
          ['\n  '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'div',([] as any[]),
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n    '])),i1.ɵncd((null as any),1),(_l()(),
          i1.ɵted((null as any),['\n  '])),(_l()(),i1.ɵted((null as any),['\n  '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),32,'div',[['class','td-paging-bar-navigation']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_TdPagingBarComponent_3)),i1.ɵdid(16384,
          (null as any),0,i4.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),9,'button',[['class','mat-icon-button'],['md-icon-button',
              ''],['type','button']],[[8,'disabled',0]],[[(null as any),'click']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:i5.TdPagingBarComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.prevPage()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i2.View_MdButton_0,i2.RenderType_MdButton)),i1.ɵdid(16384,(null as any),
          0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(180224,(null as any),0,i3.MdButton,
          [i1.ElementRef,i1.Renderer2,i3.Platform,i3.FocusOriginMonitor],{disabled:[0,
              'disabled']},(null as any)),i1.ɵdid(16384,(null as any),0,i3.MdIconButtonCssMatStyler,
          ([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted(0,['\n      '])),
      (_l()(),i1.ɵeld(0,(null as any),0,3,'md-icon',[['role','img']],[[2,'mat-icon',
          (null as any)]],(null as any),(null as any),i2.View_MdIcon_0,i2.RenderType_MdIcon)),
      i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(9027584,(null as any),
          0,i3.MdIcon,[i1.ElementRef,i1.Renderer2,i3.MdIconRegistry],(null as any),
          (null as any)),(_l()(),i1.ɵted(0,['',''])),(_l()(),i1.ɵted(0,['\n    '])),
      (_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_TdPagingBarComponent_4)),i1.ɵdid(16384,
          (null as any),0,i4.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),9,'button',[['class','mat-icon-button'],['md-icon-button',
              ''],['type','button']],[[8,'disabled',0]],[[(null as any),'click']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:i5.TdPagingBarComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.nextPage()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i2.View_MdButton_0,i2.RenderType_MdButton)),i1.ɵdid(16384,(null as any),
          0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(180224,(null as any),0,i3.MdButton,
          [i1.ElementRef,i1.Renderer2,i3.Platform,i3.FocusOriginMonitor],{disabled:[0,
              'disabled']},(null as any)),i1.ɵdid(16384,(null as any),0,i3.MdIconButtonCssMatStyler,
          ([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted(0,['\n      '])),
      (_l()(),i1.ɵeld(0,(null as any),0,3,'md-icon',[['role','img']],[[2,'mat-icon',
          (null as any)]],(null as any),(null as any),i2.View_MdIcon_0,i2.RenderType_MdIcon)),
      i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(9027584,(null as any),
          0,i3.MdIcon,[i1.ElementRef,i1.Renderer2,i3.MdIconRegistry],(null as any),
          (null as any)),(_l()(),i1.ɵted(0,['',''])),(_l()(),i1.ɵted(0,['\n    '])),
      (_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_TdPagingBarComponent_6)),i1.ɵdid(16384,
          (null as any),0,i4.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n  '])),(_l()(),i1.ɵted((null as any),
          ['\n']))],(_ck,_v) => {
    var _co:i5.TdPagingBarComponent = _v.component;
    const currVal_16:any = _co.pageSize;
    _ck(_v,5,0,currVal_16);
    _ck(_v,9,0);
    const currVal_17:any = _co.pageSizes;
    _ck(_v,13,0,currVal_17);
    const currVal_18:any = _co.pageSizeAll;
    _ck(_v,16,0,currVal_18);
    const currVal_19:any = _co.firstLast;
    _ck(_v,27,0,currVal_19);
    const currVal_21:any = _co.isMinPage();
    _ck(_v,31,0,currVal_21);
    _ck(_v,36,0);
    const currVal_24:any = (_co.pageLinkCount > 0);
    _ck(_v,41,0,currVal_24);
    const currVal_26:any = _co.isMaxPage();
    _ck(_v,45,0,currVal_26);
    _ck(_v,50,0);
    const currVal_29:any = _co.firstLast;
    _ck(_v,55,0,currVal_29);
  },(_ck,_v) => {
    var _co:i5.TdPagingBarComponent = _v.component;
    const currVal_0:any = i1.ɵnov(_v,7).ngClassUntouched;
    const currVal_1:any = i1.ɵnov(_v,7).ngClassTouched;
    const currVal_2:any = i1.ɵnov(_v,7).ngClassPristine;
    const currVal_3:any = i1.ɵnov(_v,7).ngClassDirty;
    const currVal_4:any = i1.ɵnov(_v,7).ngClassValid;
    const currVal_5:any = i1.ɵnov(_v,7).ngClassInvalid;
    const currVal_6:any = i1.ɵnov(_v,7).ngClassPending;
    const currVal_7:any = i1.ɵnov(_v,9).tabIndex;
    const currVal_8:any = i1.ɵnov(_v,9)._ariaLabel;
    const currVal_9:any = i1.ɵnov(_v,9).ariaLabelledby;
    const currVal_10:any = i1.ɵnov(_v,9).required.toString();
    const currVal_11:any = i1.ɵnov(_v,9).disabled.toString();
    const currVal_12:any = (((i1.ɵnov(_v,9)._control == null)? (null as any): i1.ɵnov(_v,
        9)._control.invalid) || 'false');
    const currVal_13:any = i1.ɵnov(_v,9)._optionIds;
    const currVal_14:any = i1.ɵnov(_v,9).disabled;
    const currVal_15:any = true;
    _ck(_v,4,1,[currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7,currVal_8,currVal_9,currVal_10,currVal_11,currVal_12,currVal_13,
        currVal_14,currVal_15]);
    const currVal_20:any = (i1.ɵnov(_v,31).disabled || (null as any));
    _ck(_v,29,0,currVal_20);
    const currVal_22:any = true;
    _ck(_v,34,0,currVal_22);
    const currVal_23:any = (_co.isRTL? 'navigate_next': 'navigate_before');
    _ck(_v,37,0,currVal_23);
    const currVal_25:any = (i1.ɵnov(_v,45).disabled || (null as any));
    _ck(_v,43,0,currVal_25);
    const currVal_27:any = true;
    _ck(_v,48,0,currVal_27);
    const currVal_28:any = (_co.isRTL? 'navigate_before': 'navigate_next');
    _ck(_v,51,0,currVal_28);
  });
}
export function View_TdPagingBarComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'td-paging-bar',
      ([] as any[]),(null as any),(null as any),(null as any),View_TdPagingBarComponent_0,
      RenderType_TdPagingBarComponent)),i1.ɵdid(114688,(null as any),0,i5.TdPagingBarComponent,
      [[2,i3.Dir]],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const TdPagingBarComponentNgFactory:i1.ComponentFactory<i5.TdPagingBarComponent> = i1.ɵccf('td-paging-bar',
    i5.TdPagingBarComponent,View_TdPagingBarComponent_Host_0,{pageSizeAll:'pageSizeAll',
        pageSizeAllText:'pageSizeAllText',firstLast:'firstLast',initialPage:'initialPage',
        pageLinkCount:'pageLinkCount',pageSizes:'pageSizes',pageSize:'pageSize',total:'total'},
    {onChange:'change'},['[td-paging-bar-label]','*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvb3Jpb24vUHJvamVjdHMvc2ltcGxpY2l0eUVuZ2luZS92YWxtdXN0L3ZhbG11c3RmZS9ub2RlX21vZHVsZXMvQGNvdmFsZW50L2NvcmUvcGFnaW5nL3BhZ2luZy1iYXIuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0M6L1VzZXJzL29yaW9uL1Byb2plY3RzL3NpbXBsaWNpdHlFbmdpbmUvdmFsbXVzdC92YWxtdXN0ZmUvbm9kZV9tb2R1bGVzL0Bjb3ZhbGVudC9jb3JlL3BhZ2luZy9wYWdpbmctYmFyLmNvbXBvbmVudC5kLnRzIiwibmc6Ly8vQzovVXNlcnMvb3Jpb24vUHJvamVjdHMvc2ltcGxpY2l0eUVuZ2luZS92YWxtdXN0L3ZhbG11c3RmZS9ub2RlX21vZHVsZXMvQGNvdmFsZW50L2NvcmUvcGFnaW5nL3BhZ2luZy1iYXIuY29tcG9uZW50Lmh0bWwiLCJuZzovLy9DOi9Vc2Vycy9vcmlvbi9Qcm9qZWN0cy9zaW1wbGljaXR5RW5naW5lL3ZhbG11c3QvdmFsbXVzdGZlL25vZGVfbW9kdWxlcy9AY292YWxlbnQvY29yZS9wYWdpbmcvcGFnaW5nLWJhci5jb21wb25lbnQuZC50cy5UZFBhZ2luZ0JhckNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgbGF5b3V0PVwicm93XCIgbGF5b3V0LWFsaWduPVwiZW5kIGNlbnRlclwiIGNsYXNzPVwibWQtY2FwdGlvbiB0ZC1wYWdpbmctYmFyXCI+XG4gIDxuZy1jb250ZW50IHNlbGVjdD1cIlt0ZC1wYWdpbmctYmFyLWxhYmVsXVwiPjwvbmctY29udGVudD5cbiAgPG1kLXNlbGVjdCBbKG5nTW9kZWwpXT1cInBhZ2VTaXplXCI+XG4gICAgPG5nLXRlbXBsYXRlIGxldC1zaXplIG5nRm9yIFtuZ0Zvck9mXT1cInBhZ2VTaXplc1wiPlxuICAgICAgPG1kLW9wdGlvbiBbdmFsdWVdPVwic2l6ZVwiPlxuICAgICAgICB7e3NpemV9fVxuICAgICAgPC9tZC1vcHRpb24+XG4gICAgPC9uZy10ZW1wbGF0ZT5cbiAgICA8bWQtb3B0aW9uICpuZ0lmPVwicGFnZVNpemVBbGxcIiBbdmFsdWVdPVwidG90YWxcIj57e3BhZ2VTaXplQWxsVGV4dH19PC9tZC1vcHRpb24+XG4gIDwvbWQtc2VsZWN0PlxuICA8ZGl2PlxuICAgIDxuZy1jb250ZW50PjwvbmctY29udGVudD5cbiAgPC9kaXY+XG4gIDxkaXYgY2xhc3M9XCJ0ZC1wYWdpbmctYmFyLW5hdmlnYXRpb25cIj5cbiAgICA8YnV0dG9uIFtpZF09XCIndGQtcGFnaW5nLWJhci0nICsgaWQgKyAnLWZpcnN0LXBhZ2UnXCIgbWQtaWNvbi1idXR0b24gdHlwZT1cImJ1dHRvblwiICpuZ0lmPVwiZmlyc3RMYXN0XCIgW2Rpc2FibGVkXT1cImlzTWluUGFnZSgpXCIgKGNsaWNrKT1cImZpcnN0UGFnZSgpXCI+XG4gICAgICA8bWQtaWNvbj57eyBpc1JUTCA/ICdza2lwX25leHQnIDogJ3NraXBfcHJldmlvdXMnIH19PC9tZC1pY29uPlxuICAgIDwvYnV0dG9uPlxuICAgIDxidXR0b24gbWQtaWNvbi1idXR0b24gdHlwZT1cImJ1dHRvblwiIFtkaXNhYmxlZF09XCJpc01pblBhZ2UoKVwiIChjbGljayk9XCJwcmV2UGFnZSgpXCI+XG4gICAgICA8bWQtaWNvbj57eyBpc1JUTCA/ICduYXZpZ2F0ZV9uZXh0JyA6ICduYXZpZ2F0ZV9iZWZvcmUnIH19PC9tZC1pY29uPlxuICAgIDwvYnV0dG9uPlxuICAgIDxuZy10ZW1wbGF0ZSAqbmdJZj1cInBhZ2VMaW5rQ291bnQgPiAwXCIgbGV0LWxpbmsgbGV0LWluZGV4PVwiaW5kZXhcIiBuZ0ZvciBbbmdGb3JPZl09XCJwYWdlTGlua3NcIj5cbiAgICAgIDxidXR0b24gW2lkXT1cIid0ZC1wYWdpbmctYmFyLScgKyBpZCArICctcGFnZS1saW5rLScgKyBpbmRleFwiIG1kLWljb24tYnV0dG9uIHR5cGU9XCJidXR0b25cIiBbY29sb3JdPVwicGFnZSA9PT0gbGluayA/ICdhY2NlbnQnIDogJydcIiAoY2xpY2spPVwibmF2aWdhdGVUb1BhZ2UobGluaylcIj57e2xpbmt9fTwvYnV0dG9uPlxuICAgIDwvbmctdGVtcGxhdGU+XG4gICAgPGJ1dHRvbiBtZC1pY29uLWJ1dHRvbiB0eXBlPVwiYnV0dG9uXCIgW2Rpc2FibGVkXT1cImlzTWF4UGFnZSgpXCIgKGNsaWNrKT1cIm5leHRQYWdlKClcIj5cbiAgICAgIDxtZC1pY29uPnt7IGlzUlRMID8gJ25hdmlnYXRlX2JlZm9yZScgOiAnbmF2aWdhdGVfbmV4dCcgfX08L21kLWljb24+XG4gICAgPC9idXR0b24+XG4gICAgPGJ1dHRvbiBbaWRdPVwiJ3RkLXBhZ2luZy1iYXItJyArIGlkICsgJy1sYXN0LXBhZ2UnXCIgbWQtaWNvbi1idXR0b24gdHlwZT1cImJ1dHRvblwiICpuZ0lmPVwiZmlyc3RMYXN0XCIgW2Rpc2FibGVkXT1cImlzTWF4UGFnZSgpXCIgKGNsaWNrKT1cImxhc3RQYWdlKClcIj5cbiAgICAgIDxtZC1pY29uPnt7IGlzUlRMID8gJ3NraXBfcHJldmlvdXMnIDogJ3NraXBfbmV4dCcgfX08L21kLWljb24+XG4gICAgPC9idXR0b24+XG4gIDwvZGl2PlxuPC9kaXY+IiwiPHRkLXBhZ2luZy1iYXI+PC90ZC1wYWdpbmctYmFyPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDR3NELDZDQUNoRDtNQUFBO1VBQUE7VUFBQTtjQUFBO01BQUE7UUFBQTtRQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtNQUFBLHFEQUFBOzBCQUFBO01BQUEsc0JBQUE7TUFBQSxtQ0FBMEI7TUFFZDtJQUZEO0lBQVgsV0FBVyxTQUFYOztJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBLFdBQUE7UUFBQSxtQkFBQTtJQUEwQjtJQUFBOzs7O29CQUk1QjtNQUFBO01BQUE7TUFBQTtNQUFBO0lBQUE7SUFBQTtNQUFBO01BQUE7SUFBQTtJQUFBO01BQUE7TUFBQTtJQUFBO0lBQUE7RUFBQSxxREFBQTtNQUFBO2FBQUE7VUFBQSxtQ0FBK0M7O0lBQWhCO0lBQS9CLFdBQStCLFNBQS9COzs7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQSxXQUFBO1FBQUEsbUJBQUE7SUFBK0M7SUFBQTs7OztvQkFNL0M7TUFBQTtNQUFBO0lBQUE7SUFBQTtJQUE2SDtNQUFBO01BQUE7SUFBQTtJQUE3SDtFQUFBLHFEQUFBO01BQUE7YUFBQTsrQkFBQSxrREFBQTtVQUFBO1VBQUEsZUFBbUosaUNBQ2pKO1VBQUE7VUFBQSw2REFBQTtVQUFBO1VBQUEsb0NBQUE7d0NBQUEsK0JBQVM7VUFBQSxVQUFxRDs7SUFEb0M7SUFBcEcsV0FBb0csU0FBcEc7SUFDRTs7O0lBRE07SUFBUjtJQUFBLFdBQVEsVUFBUixTQUFBO0lBQ0U7SUFBQSxXQUFBLFNBQUE7SUFBUztJQUFBOzs7O29CQUttRiw2Q0FDNUY7TUFBQTtVQUFBO01BQUE7UUFBQTtRQUFBO1FBQWtJO1VBQUE7VUFBQTtRQUFBO1FBQWxJO01BQUEscURBQUE7MEJBQUE7TUFBQSxzQkFBQTt1Q0FBQSw0Q0FBQTtNQUFBO01BQWlLLDRCQUFpQjs7O0lBQXhGO0lBQTFGLFdBQTBGLFNBQTFGOzs7SUFBUTtJQUFSO0lBQUEsV0FBUSxVQUFSLFNBQUE7SUFBaUs7SUFBQTs7OztvQkFEbks7TUFBQSxxQ0FBQTt1Q0FBQTs7O0lBQXdFO0lBQXhFLFdBQXdFLFNBQXhFOzs7O29CQU1BO01BQUE7TUFBQTtJQUFBO0lBQUE7SUFBNEg7TUFBQTtNQUFBO0lBQUE7SUFBNUg7RUFBQSxxREFBQTtNQUFBO2FBQUE7K0JBQUEsa0RBQUE7VUFBQTtVQUFBLGVBQWlKLGlDQUMvSTtVQUFBO1VBQUEsNkRBQUE7VUFBQTtVQUFBLG9DQUFBO3dDQUFBLCtCQUFTO1VBQUEsVUFBcUQ7O0lBRG1DO0lBQW5HLFdBQW1HLFNBQW5HO0lBQ0U7OztJQURNO0lBQVI7SUFBQSxXQUFRLFVBQVIsU0FBQTtJQUNFO0lBQUEsV0FBQSxTQUFBO0lBQVM7SUFBQTs7OztvQkEzQmY7TUFBQTtNQUFBLHdFQUE2RTthQUFBLGlDQUMzRSxrQkFBd0Q7TUFBQSxXQUN4RDtNQUFBO01BQUE7TUFBQTtVQUFBO1VBQUE7TUFBQTtNQUFBO0lBQUE7SUFBQTtJQUFBO01BQUE7TUFBQTtJQUFBO0lBQUE7TUFBQTtNQUFBO0lBQUE7SUFBVztNQUFBO01BQUE7SUFBQTtJQUFYO0VBQUEscURBQUE7TUFBQTtVQUFBLDJDQUFBO01BQUEsbUNBQUE7TUFBQSxtREFBQTtNQUFBO2FBQUE7K0JBQUE7VUFBQSxnREFBa0M7TUFDaEM7YUFBQTs0QkFBQSx5Q0FJYztVQUFBLGFBQ2Q7YUFBQTtVQUFBLHdCQUE4RSw2QkFDcEU7VUFBQSxXQUNaO1VBQUE7TUFBSyxrREFDSCxrQkFBeUI7aUJBQUEsMEJBQ3JCO01BQ047VUFBQTtNQUFzQywyQ0FDcEM7VUFBQSxtRUFBQTtVQUFBO1VBQUEsZUFFUywyQ0FDVDtVQUFBO2NBQUE7VUFBQTtZQUFBO1lBQUE7WUFBOEQ7Y0FBQTtjQUFBO1lBQUE7WUFBOUQ7VUFBQSxxREFBQTtVQUFBO1VBQUEsb0NBQUE7VUFBQTtjQUFBLG1DQUFBO1VBQUEsMkNBQW1GO01BQ2pGO1VBQUE7YUFBQTt1QkFBQSxzQ0FBQTtVQUFBO1VBQUEsZUFBUyw0QkFBMkQ7TUFDN0QsMkNBQ1Q7VUFBQSxtRUFBQTtVQUFBO1VBQUEsZUFFYywyQ0FDZDtVQUFBO2NBQUE7VUFBQTtZQUFBO1lBQUE7WUFBOEQ7Y0FBQTtjQUFBO1lBQUE7WUFBOUQ7VUFBQSxxREFBQTtVQUFBO1VBQUEsb0NBQUE7VUFBQTtjQUFBLG1DQUFBO1VBQUEsMkNBQW1GO01BQ2pGO1VBQUE7YUFBQTt1QkFBQSxzQ0FBQTtVQUFBO1VBQUEsZUFBUyw0QkFBMkQ7TUFDN0QsMkNBQ1Q7VUFBQSxtRUFBQTtVQUFBO1VBQUEsZUFFUyx5Q0FDTDtVQUFBOztJQTNCSztJQUFYLFdBQVcsVUFBWDtJQUFBO0lBQzhCO0lBQTVCLFlBQTRCLFVBQTVCO0lBS1c7SUFBWCxZQUFXLFVBQVg7SUFNa0Y7SUFBbEYsWUFBa0YsVUFBbEY7SUFHcUM7SUFBckMsWUFBcUMsVUFBckM7SUFDRTtJQUVXO0lBQWIsWUFBYSxVQUFiO0lBR3FDO0lBQXJDLFlBQXFDLFVBQXJDO0lBQ0U7SUFFK0U7SUFBakYsWUFBaUYsVUFBakY7OztJQXhCRjtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtRQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUEsWUFBQTtRQUFBO1FBQUEscUJBQUE7SUFlRTtJQUFBLFlBQUEsVUFBQTtJQUNFO0lBQUEsWUFBQSxVQUFBO0lBQVM7SUFBQTtJQUtYO0lBQUEsWUFBQSxVQUFBO0lBQ0U7SUFBQSxZQUFBLFVBQUE7SUFBUztJQUFBOzs7O29CQ3hCZjtNQUFBO3FDQUFBLFVBQUE7TUFBQTtJQUFBOzs7Ozs7OyJ9



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/$$_gendir/~/@covalent/core/paging/paging-bar.component.ngfactory.ts